import React from "react";
import styled from "styled-components";
import ProjectBanner from "assets/images/jpgs/ProjectBanner.jpg";
import {
  TKIconFlutter,
  TKIconMastercard,
  TKIconPaypal,
  TKIconVisa,
} from "assets/images/svgs";
import DonateCard from "features/HomePage/components/DonateCard";
import Donate from "assets/images/jpgs/Donate.png";
import LadySmiling from "assets/images/jpgs/LadySmiling.jpg";
import Footer from "shared/Footer";
import EmptyProjects from "shared/EmptyProjects";

const Banner = ({ result }) => {
  const theme = ["bg-[#FF8F41]", "bg-[#61CE70]", "bg-[#0693E3]"];

  return (
    <div className="relative">
      <BannerContainer>
        <BannerTextWrapper>
          <h1>DONATE NOW</h1>
          <p>
            Support Charity Projects that are improving communities across
            Nigeria
          </p>
          <div className="flex gap-4">
            <TKIconPaypal />
            <TKIconVisa />
            <TKIconMastercard />
            <TKIconFlutter />
          </div>
        </BannerTextWrapper>
        <div className="w-full absolute top-[53.8%] pt-16 justify-center flex flex-col gap-6">
          <div className="px-16 max-[450px]:px-8">
            <div className="flex gap-6 justify-center mb-2 items-center flex-wrap">
              {!result || result?.length < 1 ? (
                <div className="mt-64 mb-24 max-md:mt-48 max-md:mb-12">
                  <EmptyProjects />
                </div>
              ) : (
                result?.map((donateCard, idx) => (
                  <div
                    key={donateCard._id}
                    className="w-[280px] flex justify-center"
                  >
                    <DonateCard
                      id={donateCard._id}
                      cardImage={donateCard.project_picture}
                      title={donateCard.name}
                      body={donateCard.summary}
                      amountRaised={donateCard.amountDonated}
                      targetAmount={donateCard.fundraising_goal}
                      bgColor={theme[idx % 3]}
                    />
                  </div>
                ))
              )}
            </div>
            <BottomSection>
              <div className="flex max-sm:flex-col items-center gap-2 justify-between">
                <div>
                  <p className="leading-[38px] text-[23px] lg:text-[32px] font-bold">
                    Contact us for info now
                  </p>
                </div>
                <div>
                  <img src={Donate} alt="Donate items" />
                </div>
                <div>
                  <p className="leading-[38px] text-[23px] lg:text-[32px] font-bold">
                    info@truekeepers.org
                  </p>
                </div>
              </div>
            </BottomSection>
          </div>
          <Footer />
        </div>
      </BannerContainer>
    </div>
  );
};

export default Banner;

const BannerContainer = styled.div`
  background: linear-gradient(
      0deg,
      rgba(34, 34, 34, 0.7),
      rgba(34, 34, 34, 0.7)
    ),
    url(${ProjectBanner});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: calc(100vh - 71px - 87px); */
  position: relative;
  height: 507px;
`;
const BannerTextWrapper = styled.div`
  width: 40%;
  color: white;
  display: flex;
  position: absolute;
  top: 25%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  text-align: center;

  @media screen and (max-width: 550px) {
    width: 60%;
  }

  h1 {
    font-weight: 800;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.08em;
  }
`;
const BottomSection = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    url(${LadySmiling});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  color: #ffffff;
  width: 100%;
  min-height: 80px;
  margin: 30px 0;
`;
